import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-6 sm:p-8 max-w-xl" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-8" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-[#6CC551] text-xs font-bold uppercase tracking-widest mb-1" }, "Administration"),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-extrabold text-[#1E2833]" }, "Add User")
], -1)
const _hoisted_3 = { class: "bg-white rounded-2xl border border-gray-100 p-8 space-y-6" }

import { url } from "@/functions/endpoint";
import router from "@/router";
import axios from "axios";
import { initTooltips } from "flowbite";
import { onMounted, reactive, ref } from "vue";
import InputField from "@/components/Inputs/InputField.vue";
import Button from "@/components/Inputs/Button.vue"
import SuccessMessage from "@/components/SuccessMessage.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddUser',
  setup(__props) {

onMounted(() => {
    initTooltips();
});

const uploading = ref(false);
let successMessage = ref<string>('');
let showSuccessMessage = ref<boolean>(false);
let errorAlert = ref<boolean>(false);
let errorMessage = ref<string>('');
const isEditing = ref<boolean>(false);

const createUser = reactive({
    username: "",
    email: "",
    password: "",
    retypePassword: ""
})

const handleAddUser = async () => {
    const userData = {
        username: createUser.username,
        email: createUser.email,
        password: createUser.password,
        retypedPassword: createUser.retypePassword
    }

    try {
        if (!isEditing.value) {
            await axios.post(`${url}/admin/auth/create`, userData)
                .then((response) => {
                    showSuccessMessage.value = true
                    successMessage.value = response.data.message;
                })
        } else {
            //   await axios.patch(`${url}/departments/update/${postId.value}`, { name: data.title, about: data.description, })
        }

        setTimeout(() => {
            showSuccessMessage.value = false;

            if (isEditing.value) {
                // router.push('/admin/view-departments');
            } else {
                window.location.href = "/admin/add-user"
            }
        }, 1000);
    }
    catch (error: any) {
        errorAlert.value = true;
        errorMessage.value = error.message;
        setTimeout(() => {
            errorAlert.value = false;
        }, 5000)
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(InputField, {
          label: "Username",
          id: "username",
          type: "text",
          placeholder: "Enter username",
          isRequired: true,
          modelValue: createUser.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createUser.username) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(InputField, {
          label: "Email",
          id: "email",
          type: "email",
          placeholder: "Enter email",
          isRequired: true,
          modelValue: createUser.email,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createUser.email) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(InputField, {
          label: "Password",
          id: "password",
          type: "password",
          placeholder: "Enter password",
          isRequired: true,
          modelValue: createUser.password,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createUser.password) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(InputField, {
          label: "Re-enter Password",
          id: "retype",
          type: "password",
          placeholder: "Re-enter Password",
          isRequired: true,
          modelValue: createUser.retypePassword,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createUser.retypePassword) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(Button, {
          buttonText: 'Add User',
          isDisabled: createUser.username === '' || !createUser.email || createUser.password === '' || createUser.retypePassword === '' || uploading.value,
          uploading: uploading.value,
          handleClick: handleAddUser
        }, null, 8, ["isDisabled", "uploading"])
      ])
    ]),
    _createVNode(SuccessMessage, {
      showSuccessMessage: _unref(showSuccessMessage),
      successMessage: _unref(successMessage)
    }, null, 8, ["showSuccessMessage", "successMessage"]),
    _createVNode(ErrorMessage, {
      errorAlert: _unref(errorAlert),
      errorMessage: _unref(errorMessage)
    }, null, 8, ["errorAlert", "errorMessage"])
  ], 64))
}
}

})